<nav *ngIf='isShowHeader()  && user' class='navbar navbar-expand-lg'>
  <a class='navbar-brand'>
    <span class="accent">Stocks</span>
    <span class="white">Portfolio</span>
    </a>
  <button class='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarSupportedContent' aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
      <i class='fa fa-bars'></i>
  </button>
  <div class='collapse navbar-collapse' id='navbarSupportedContent'>
      <ul class='navbar-nav ml-auto'>
          <li *ngIf="!userService.isAdminUser(user.email)" class="nav-item">
              <a routerLink="/dashboard" class="nav-link">Dashboard</a>
          </li>
          <li class="nav-item">
            <a routerLink="/scoreboard" class="nav-link">Scoreboard</a>
          </li>
          <li class="nav-item">
            <a (click)="signOut()" class="nav-link">Sign Out</a>
          </li>
      </ul>
  </div>
</nav>
<div class="router-outlet">
  <router-outlet></router-outlet>
</div><footer class="footer">
    <h1 class="footer-title">&copy; {{dataService.returnTime().year}} All Rights Reserved.  This application is designed and developed by Som Shrivastava.</h1>
</footer>
<p-toast position="bottom-left"></p-toast>